import { render, staticRenderFns } from "./CookieInfo.vue?vue&type=template&id=43854179&scoped=true&"
import script from "./CookieInfo.vue?vue&type=script&lang=js&"
export * from "./CookieInfo.vue?vue&type=script&lang=js&"
import style0 from "./CookieInfo.vue?vue&type=style&index=0&id=43854179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43854179",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
